import { useMemo } from 'react';
import { hasMigrationDataForProject } from './utils.tsx';

export const useHasListMigrationDataForProject = (projectId?: string | null) => {
	return useMemo(() => (projectId ? hasMigrationDataForProject(projectId) : false), [projectId]);
};
